"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthRoutes = void 0;
const routes_1 = require("./routes");
const guest_middleware_1 = require("./HOC/guest-middleware");
const LoginScene_1 = require("./scenes/LoginScene/LoginScene");
const ForgotScene_1 = require("./scenes/ForgotScene/ForgotScene");
const ForgotSuccessScene_1 = require("./scenes/ForgotSuccessScene/ForgotSuccessScene");
const ResetPasswordScene_1 = require("./scenes/ResetPasswordScene/ResetPasswordScene");
const ResetPasswordSuccessScene_1 = require("./scenes/ResetPasswordSuccessScene/ResetPasswordSuccessScene");
const AcceptInvitationScene_1 = require("./scenes/AcceptInvitationScene/AcceptInvitationScene");
const AcceptInvitationSuccessScene_1 = require("./scenes/AcceptInvitationSuccessScene/AcceptInvitationSuccessScene");
const AuthErrorScene_1 = require("./scenes/AuthErrorScene/AuthErrorScene");
const ConfirmScene_1 = require("./scenes/ConfirmScene/ConfirmScene");
const LogoutScene_1 = require("./scenes/LogoutScene/LogoutScene");
const config_1 = require("./config");
exports.getAuthRoutes = () => {
    const r = [
        {
            url: routes_1.routes.RESET,
            component: guest_middleware_1.guestMiddleware(ResetPasswordScene_1.ResetPasswordScene),
        },
        {
            url: routes_1.routes.RESET_SUCCESS,
            component: guest_middleware_1.guestMiddleware(ResetPasswordSuccessScene_1.ResetPasswordSuccessScene),
        },
        {
            url: routes_1.routes.ERROR,
            component: AuthErrorScene_1.AuthErrorScene,
        },
        {
            url: routes_1.routes.ACCEPT_INVITATION,
            component: guest_middleware_1.guestMiddleware(AcceptInvitationScene_1.AcceptInvitationScene),
        },
        {
            url: routes_1.routes.ACCEPT_INVITATION_SUCCESS,
            component: guest_middleware_1.guestMiddleware(AcceptInvitationSuccessScene_1.AcceptInvitationSuccessScene),
        },
        {
            url: routes_1.routes.CONFIRM,
            component: ConfirmScene_1.ConfirmScene,
        },
    ];
    if (!config_1.getReleoxOption('mobileSupportOnly')) {
        r.push({
            url: routes_1.routes.LOGIN,
            component: guest_middleware_1.guestMiddleware(LoginScene_1.LoginScene),
        }, {
            url: routes_1.routes.FORGOT,
            component: guest_middleware_1.guestMiddleware(ForgotScene_1.ForgotScene),
        }, {
            url: routes_1.routes.FORGOT_SUCCESS,
            component: guest_middleware_1.guestMiddleware(ForgotSuccessScene_1.ForgotSuccessScene),
        }, {
            url: routes_1.routes.LOGOUT,
            component: LogoutScene_1.LogoutScene,
        });
    }
    return r;
};
//# sourceMappingURL=auth-routes.js.map